import type { ReactNode } from "react";
import { AppShell } from "@/components/AppShell";

interface Props {
  eyebrow?: string;
  title: string;
  intro?: string;
  children: ReactNode;
}

export function DocPage({ eyebrow, title, intro, children }: Props) {
  return (
    <AppShell>
      <article className="mx-auto max-w-3xl">
        <header className="mb-8">
          {eyebrow && <div className="text-xs font-semibold uppercase tracking-wider text-primary">{eyebrow}</div>}
          <h1 className="mt-1 font-display text-4xl font-black tracking-tight">{title}</h1>
          {intro && <p className="mt-3 text-base text-muted-foreground">{intro}</p>}
        </header>
        <div className="prose-doc space-y-6">{children}</div>
      </article>

      <style>{`
        .prose-doc h2 { font-family: var(--font-display, "Space Grotesk", system-ui); font-size: 1.4rem; font-weight: 700; margin-top: 1.5rem; }
        .prose-doc h3 { font-size: 1.05rem; font-weight: 700; margin-top: 1rem; }
        .prose-doc p, .prose-doc li { color: color-mix(in oklab, var(--color-foreground) 80%, transparent); line-height: 1.65; }
        .prose-doc ul { list-style: disc; padding-left: 1.25rem; }
        .prose-doc ol { list-style: decimal; padding-left: 1.25rem; }
        .prose-doc a { color: var(--color-primary); text-decoration: underline; text-underline-offset: 2px; }
        .prose-doc .panel-note { border: 1px solid var(--color-border); background: color-mix(in oklab, var(--color-panel) 60%, transparent); padding: 1rem 1.25rem; border-radius: 0.5rem; }
      `}</style>
    </AppShell>
  );
}
